import { E_AlarmType } from '@/api/enums'
import { E_AlarmAttachType, E_DealStatus, IAlarmDetail, IGetFaultanAlysisStatisticsData } from '@/api/moudules/alarm.types'
import { E_DiagnosticResults, E_FaultType } from '@/api/moudules/fault.types'
import { E_FaultCaseLibraryIsPublic } from '@/api/moudules/faultCaseLibrary.types'
import { E_ModelPartial } from '@/api/moudules/model.types'
import { E_Axis } from '@/api/moudules/sensor.types'
import { E_WeeklyReportEquipmentStatus } from '@/api/moudules/weeklyReport.types'
import { IReferenceItem } from '@/components/FaultAnalysisDetail/FaultAnalysisReference/FaultAnalysisReferenceImpl'
import { gVm } from '@/global'
import { RE_Diagnosis } from '@/i18n/replace'
import { EnumTrans } from '@/i18n/trans'
import { formatTemplate, formatVibration, formatVoltage } from '@/mixin/format'
import { E_FaultAlysisStatistics } from '@/types'
import { formatDateTime } from '@/utils/datetime'
import { appendUnitFromAlarmType } from '@/utils/units'
import _ from 'lodash'
import Vue from 'vue'

export function reformatDiagnosis(vm: Vue, diagnosis: string, item: {
    vibrateStatus: E_WeeklyReportEquipmentStatus,
    // currentStatus: E_WeeklyReportEquipmentStatus,
    temStatus: E_WeeklyReportEquipmentStatus,
    steepStatus: E_WeeklyReportEquipmentStatus,
    peakStatus: E_WeeklyReportEquipmentStatus,
}) {
    if (!RE_Diagnosis.test(diagnosis)) {
        return diagnosis
    }
    const w = vm.$enumTrans.WeeklyReportEquipmentStatus
    return vm.$t('weeklyReport.diagnosisTemplate', {
        vibrate: w(item.vibrateStatus),
        tem: w(item.temStatus),
        steep: w(item.steepStatus),
        peak: w(item.peakStatus),
    }) as string
}

export function reformatFullSuggest($enumTrans: EnumTrans, faultTypeIds: string, suggest: string) {
    if (!faultTypeIds) {
        return reformatSuggest(suggest)
    }
    const faultTypes = _.map(_.split(faultTypeIds, ','), x => {
        let faultType = _.toInteger(x) as E_FaultType
        return faultType
    })
    return _.join(_.map(faultTypes, faultType => {
        var diagnosisResult = faultTypeToDiagnosticResults(faultType)
        var faultTypeShow = $enumTrans.FaultType(faultType)
        var diagnosisResultShow = $enumTrans.DiagnosticResults(diagnosisResult)
        return `${faultTypeShow}:${diagnosisResultShow}`
    }), ' ')
}

export function reformatSuggest(suggest: string, separator = '<br/>') {
    let parts = _.split(suggest, '\\n')
    parts = _.filter(parts, p => !_.isEmpty(p))
    return _.join(parts, separator)
}

export function collectionReferenceItems(data: IGetFaultanAlysisStatisticsData): IReferenceItem[] {
    data = data || {} as any
    const {
        componentType,
        bearingBreath, bearingPercentage,
        misaligned, misalignedPercentage,
        looseness, loosenessPercentage,
        imbalance, imbalancePercentage,
        unevenBreath, unevenBreathPercentage,
        resonance, resonancePercentage,
    } = data

    // 获取参考值
    let reference = [
        {
            kind: E_FaultAlysisStatistics.looseness,
            value: looseness,
            percentage: loosenessPercentage,
        }, {
            kind: E_FaultAlysisStatistics.bearingBreath,
            value: bearingBreath,
            percentage: bearingPercentage,
        }, {
            kind: E_FaultAlysisStatistics.misaligned,
            value: misaligned,
            percentage: misalignedPercentage,
        }, {
            kind: E_FaultAlysisStatistics.unevenBreath,
            value: unevenBreath,
            percentage: unevenBreathPercentage,
        }, {
            kind: E_FaultAlysisStatistics.imbalance,
            value: imbalance,
            percentage: imbalancePercentage,
        }, {
            kind: E_FaultAlysisStatistics.resonance,
            value: resonance,
            percentage: resonancePercentage,
        }]

    switch (componentType) {
        case E_ModelPartial.Fans:
            reference.push({
                kind: E_FaultAlysisStatistics.fanBreath,
                value: data.fanBreath,
                percentage: data.fanPercentage,
            })
            break;
        case E_ModelPartial.WaterPump:
            reference.push({
                kind: E_FaultAlysisStatistics.pumpBreath,
                value: data.pumpBreath,
                percentage: data.pumpPercentage,
            })
            break;
        case E_ModelPartial.Cogs:
            const {
                gearBBreath,
                gearBPercentage,
                gearFBreath,
                gearFPercentage,
                gearMBreath,
                gearMPercentage,
            } = data
            reference = [...reference, {
                kind: E_FaultAlysisStatistics.gearBBreath,
                value: gearBBreath,
                percentage: gearBPercentage,
            }, {
                kind: E_FaultAlysisStatistics.gearFBreath,
                value: gearFBreath,
                percentage: gearFPercentage,
            }, {
                kind: E_FaultAlysisStatistics.gearMBreath,
                value: gearMBreath,
                percentage: gearMPercentage,
            }]
            break;
    }
    return reference
}

function buildAlarmTooltip(axis: string, x: number, y: number, z: number, sep = ',') {
    if (!axis) return ''
    let parts = []
    if (axis.search('X') !== -1) {
        parts.push(`x: ${x}`)
    }
    if (axis.search('Y') !== -1) {
        parts.push(`y: ${y}`)
    }
    if (axis.search('Z') !== -1) {
        parts.push(`z: ${z}`)
    }
    return parts.join(sep)
}

interface IXYZThresold {
    x: number
    y: number
    z: number
}

function safeShowThresold(c: number, d?: number) {
    let hasC = !_.isNil(c)
    let hasD = !_.isNil(d)
    if (!hasC && !hasD) {
        return
    }
    let values = [
        ...hasC ? [c] : [],
        ...hasD ? [d] : []
    ]
    return '(' + values.join(' , ') + ')'
}

function buildAlarmThresold(axis: string, c: IXYZThresold, d?: IXYZThresold) {
    if (!axis) return ''
    let parts = []
    if (axis.search('X') !== -1) {
        let r = safeShowThresold(c.x, d?.x)
        if (r) {
            parts.push('x:' + r)
        }
    }
    if (axis.search('Y') !== -1) {
        let r = safeShowThresold(c.y, d?.y)
        if (r) {
            parts.push('y:' + r)
        }
    }
    if (axis.search('Z') !== -1) {
        let r = safeShowThresold(c.z, d?.z)
        if (r) {
            parts.push('z:' + r)
        }
    }
    return parts.join('<br>')
}

export interface IAlaramValueCollect {
    alarmValue: number
    alarmType: E_AlarmType
    alarmAxis: string
    battery: number
    kurtX: number
    kurtY: number
    kurtZ: number
    peakX: number
    peakY: number
    peakZ: number
    envelopeX: number
    envelopeY: number
    envelopeZ: number
    vx: number
    vy: number
    vz: number
    tem: number

    /**
     * 趋势报警
     */
    slopeX: number
    slopeY: number
    slopeZ: number
}

export interface IAlaramValueCollectEx extends IAlaramValueCollect {
    /**
     * 报警时阈值，(温度/电压使用xcMax/xDMax)
     */
    xcMax: number
    xdMax: number
    ycMax: number
    ydMax: number
    zcMax: number
    zdMax: number
    azhigh: number    
}

export function getAlaramValueDisplayEx(params: IAlaramValueCollectEx) {
    const {
        alarmAxis,
        alarmType,
        alarmValue,
        battery,
        kurtX,
        kurtY,
        kurtZ,
        peakX,
        peakY,
        peakZ,
        vx,
        vy,
        vz,
        tem,
        xcMax,
        xdMax,
        ycMax,
        ydMax,
        zcMax,
        zdMax,
        azhigh,
        envelopeX,
        envelopeY,
        envelopeZ,
        slopeX,
        slopeY,
        slopeZ,
    } = params
    let tooltip = ''
    let thresold = ''
    let cThresold = { x: xcMax, y: ycMax, z: zcMax }
    let dThresold = { x: xdMax, y: ydMax, z: zdMax }
    let br = '<br>'
    switch (alarmType) {
        case E_AlarmType.Vibration:
            tooltip = buildAlarmTooltip(alarmAxis, vx, vy, vz, br)
            thresold = buildAlarmThresold(alarmAxis, cThresold, dThresold)
            break
        case E_AlarmType.Steepness:
            tooltip = buildAlarmTooltip(alarmAxis, kurtX, kurtY, kurtZ, br)            
            thresold = buildAlarmThresold(alarmAxis, cThresold, dThresold)
            break
        case E_AlarmType.Crest:
            tooltip = _.toString(alarmValue)
            thresold = buildAlarmThresold(alarmAxis, cThresold, dThresold)
            break
        case E_AlarmType.Envelope:
            tooltip = buildAlarmTooltip(alarmAxis, envelopeX, envelopeY, envelopeZ, br)
            thresold = buildAlarmThresold(alarmAxis, cThresold, dThresold)
            break
        case E_AlarmType.Temperature:
            tooltip = _.toString(tem)
            thresold = safeShowThresold(xcMax, xdMax)
            break
        case E_AlarmType.Voltage:
            tooltip = _.toString(battery)
            thresold = safeShowThresold(xcMax, xdMax)
            break
        case E_AlarmType.Offline:
            break
        case E_AlarmType.Electricity:
            // 暂时没有
            break
        case E_AlarmType.HighFrequencyAcceleration:
            tooltip = _.toString(azhigh)
            thresold = safeShowThresold(zcMax, zdMax)
            break
        case E_AlarmType.Slope:
            tooltip = buildAlarmTooltip(alarmAxis, slopeX, slopeY, slopeZ, br)
            thresold = buildAlarmThresold(alarmAxis, cThresold)
            break
    }
    return {
        value: tooltip,
        thresold,
    }
}

export function getAlaramValueDisplay(params: IAlaramValueCollect) {
    const {
        alarmAxis,
        alarmType,
        battery,
        kurtX,
        kurtY,
        kurtZ,
        peakX,
        peakY,
        peakZ,
        vx,
        vy,
        vz,
        tem,
    } = params
    let tooltip = ''
    switch (alarmType) {
        case E_AlarmType.Vibration:
            tooltip = buildAlarmTooltip(alarmAxis, vx, vy, vz)
            break
        case E_AlarmType.Steepness:
            tooltip = buildAlarmTooltip(alarmAxis, kurtX, kurtY, kurtZ)
            break
        case E_AlarmType.Crest:
            tooltip = buildAlarmTooltip(alarmAxis, peakX, peakY, peakZ)
            break
        case E_AlarmType.Temperature:
            tooltip = _.toString(tem)
            break
        case E_AlarmType.Voltage:
            tooltip = _.toString(battery)
            break
        case E_AlarmType.Offline:
            break
        case E_AlarmType.Electricity:
            // 暂时没有
            break
    }
    return tooltip
}

export function exAlarmDetail<T extends IAlarmDetail>(alarm: T) {
    const {
        createTime,
        attachVOList,
    } = alarm
    const attachVOGroup = _.groupBy(attachVOList || [], item => {
        return item.attachType
    })
    let {
        value: alarmValue,
        thresold: alarmThresold,
    } = getAlaramValueDisplayEx(alarm)
    let alarmValueShow = appendUnitFromAlarmType(alarm.alarmType, alarmValue)
    return {
        createTimeShow: formatDateTime(createTime),
        ...alarm,
        alarmValueShow,
        alarmThresold,
        audioList: attachVOGroup[E_AlarmAttachType.Audio] || [],
        imageList: attachVOGroup[E_AlarmAttachType.Image] || [],
    }
}

export type IAlarmDetailEx = ReturnType<typeof exAlarmDetail>



export function dealStatusFromString(s: string) {
    switch (s) {
        case '未处理':
            return E_DealStatus.UnHandled
        case '自动终止':
            return E_DealStatus.AutoHandled
        case '人工处理':
            return E_DealStatus.ManualHandled
    }
}

export function faultTypeToDiagnosticResults(faultType: E_FaultType) {
    return {
        [E_FaultType.RESONANCE_TYPE]: E_DiagnosticResults.RESONANCE_RECOMMENDATION,
        [E_FaultType.OUTOFFBALANCE_TYPE]: E_DiagnosticResults.OUTOFFBALANCE_RECOMMENDATION,
        [E_FaultType.MISALIGNMENT_TYPE]: E_DiagnosticResults.MISALIGNMENT_RECOMMENDATION,
        [E_FaultType.FOUNDATION_LOOSE_TYPE]: E_DiagnosticResults.FOUNDATION_LOOSE_RECOMMENDATION,
        [E_FaultType.UNEVEN_AIR_GAP_TYPE]: E_DiagnosticResults.UNEVEN_AIR_GAP_RECOMMENDATION,
        [E_FaultType.DAMAGED_HOLDER_TYPE]: E_DiagnosticResults.DAMAGED_HOLDER_RECOMMENDATION,
        [E_FaultType.ROLLING_ELEMENT_DAMAGED_TYPE]: E_DiagnosticResults.ROLLING_ELEMENT_DAMAGED_RECOMMENDATION,
        [E_FaultType.INNER_RING_DAMAGED_TYPE]: E_DiagnosticResults.INNER_RING_DAMAGED_RECOMMENDATION,
        [E_FaultType.OUTER_RING_DAMAGED_TYPE]: E_DiagnosticResults.OUTER_RING_DAMAGED_RECOMMENDATION,
        [E_FaultType.POOR_LUBRICATION_TYPE]: E_DiagnosticResults.POOR_LUBRICATION_RECOMMENDATION,
        [E_FaultType.EXPERT_ANALYSIS_TYPE]: E_DiagnosticResults.EXPERT_ANALYSIS_RECOMMENDATION,
        [E_FaultType.WATER_PUMP_TYPE]: E_DiagnosticResults.WATER_HOUSING_RECOMMENDATION,
        [E_FaultType.GEAR_WEAR_TYPE]: E_DiagnosticResults.GEAR_ANALYSIS_RECOMMENDATION,
        [E_FaultType.GEAR_LOAD_TYPE]: E_DiagnosticResults.GEAR_LOAD_RECOMMENDATION,
        [E_FaultType.GEAR_ALIGNMENT_TYPE]: E_DiagnosticResults.GEAR_ALIGNMENT_RECOMMENDATION,
        [E_FaultType.FAN_FRICTION_TYPE]: E_DiagnosticResults.GEAR_FRICTION_RECOMMENDATION,
    }[faultType]
}


export const IsPublicOptions = Object.freeze([
    E_FaultCaseLibraryIsPublic.No,
    E_FaultCaseLibraryIsPublic.Yes,
])
